/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { GuardIcon } from '@atlaskit/logo';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const styles = cssMap({
	container: {
		paddingBlock: token('space.150'),
	},
	enforcementRow: {
		font: token('font.body.small'),
		color: token('color.text.subtle'),
	},
	bodyText: {
		font: token('font.body.small'),
		color: token('color.text.subtle'),
	},
	traceIdRow: {
		font: token('font.body.small'),
		color: token('color.text.subtlest'),
	},
});

/**
 * Renders the Guard block experience — shown when a user's prompt is blocked
 * by an Atlassian Guard data protection policy.
 */
export const StoreGuardBlockView = ({
	traceId,
	blockType,
}: {
	traceId?: string;
	blockType?: 'PROMPT_BLOCKED' | 'RESPONSE_BLOCKED' | 'ATTACHMENT_BLOCKED';
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const bodyMessage =
		blockType === 'RESPONSE_BLOCKED'
			? formatMessage(messages.blockedResponseBodyResponseBlocked)
			: formatMessage(messages.blockedResponseBody);

	return (
		<Box xcss={styles.container}>
			<Stack space="space.100">
				<Inline space="space.050" alignBlock="center" xcss={styles.enforcementRow}>
					<GuardIcon appearance="brand" shouldUseNewLogoDesign size="xsmall" />
					<Text>{formatMessage(messages.enforcementMessage)}</Text>
				</Inline>
				<Box xcss={styles.bodyText}>
					<Text>{bodyMessage}</Text>
				</Box>
				{traceId && (
					<Box xcss={styles.traceIdRow}>
						<Text>{formatMessage(messages.traceId, { traceId })}</Text>
					</Box>
				)}
			</Stack>
		</Box>
	);
};
